import Vue from 'vue';
import Router from 'vue-router';
// import Home from './views/Home.vue';
// import cookies from 'js-cookie';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    // {
    //   path: '/',
    //   name: 'home',
    //   component: Home
    // },
    {
      path: '/login',
      name: 'login',
      component: () =>
        import(/* webpackChunkName: "login" */ './views/Login.vue')
    },
    {
      path: '/signup',
      name: 'signup',
      component: () =>
        import(/* webpackChunkName: "signup" */ './views/Signup.vue')
    },
    {
      path: '/forgot',
      name: 'forgot',
      component: () =>
        import(/* webpackChunkName: "forgot" */ './views/Forgot.vue')
    },
    {
      path: '/reset',
      name: 'reset',
      component: () =>
        import(/* webpackChunkName: "reset" */ './views/Reset.vue')
    },
    {
      path: '/downloads',
      name: 'download',
      component: () =>
        import(/* webpackChunkName: "download" */ './views/Download.vue')
    },
    {
      path: '/groups',
      name: 'groups',
      component: () =>
        import(/* webpackChunkName: "group" */ './views/Groups.vue')
    },
    {
      path: '/profile',
      name: 'profile',
      component: () =>
        import(/* webpackChunkName: "profile" */ './views/Profile.vue')
    },
    {
      path: '/team/members',
      name: 'teammembers',
      component: () =>
        import(/* webpackChunkName: "team" */ './views/TeamMembers.vue')
    },
    {
      path: '/team/profile',
      name: 'teamprofile',
      component: () =>
        import(/* webpackChunkName: "team" */ './views/TeamProfile.vue'),
      meta: {
        owner: true
      }
    },
    {
      path: '/account',
      alias: '/',
      name: 'account',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "account" */ './views/Account.vue')
    },
    {
      path: '/billing',
      name: 'billing',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "account" */ './views/Billing.vue')
    },
    {
      path: '/accountstatus',
      name: 'accountstatus',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () =>
        import(/* webpackChunkName: "account" */ './views/AccountStatus.vue')
    }
  ]
});

router.beforeEach((to, from, next) => {
  try {
    const publicPages = ['/reset', '/forgot', '/signup', '/login'];
    //const ownerPages = ['/teamprofile'];
    const authRequired = !publicPages.includes(to.path);
    const loggedIn = localStorage.gmxt || false;
    if (authRequired && !loggedIn) {
      if (to.path === '/') {
        // just removing unsightly redirect for /
        return next({ path: '/login' });
      }
      return next({
        path: '/login',
        query: { redirect: to.fullPath }
      });
    }
    if (loggedIn && publicPages.includes(to.path)) {
      if (to.path === '/forgot') {
        return next();
      } else {
        return next('/account');
      }
    }
    // if (ownerPages.includes(to.path)) {
    //   if (!store.getters['auth/isTeamOwner']) {
    //     return next(false);
    //   }
    // }
    next();
  } catch (e) {
    console.log('Router exception caught and cuddled.');
  }
});

export default router;
